import { z } from 'zod';

export const addToWipValidationSchema = z.object({
  workItemType: z.enum(['backlog', 'currentWork']),
});

export type AddToWipFormValuesT = z.infer<typeof addToWipValidationSchema>;
